export type PageToken = number | 'ellipsis';

/**
 * Builds a compact page list (max ~7 tokens): 1 … 5 6 7 … 12
 */
export function getVisiblePages(currentPage: number, totalPages: number): PageToken[] {
  const total = Math.max(0, Math.floor(totalPages));
  const current = Math.min(Math.max(1, Math.floor(currentPage)), Math.max(1, total));
  if (total <= 0) return [];
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages = new Set<number>([1, total]);
  for (let i = current - 1; i <= current + 1; i += 1) {
    if (i >= 1 && i <= total) pages.add(i);
  }
  if (current <= 3) {
    pages.add(2);
    pages.add(3);
    pages.add(4);
  }
  if (current >= total - 2) {
    pages.add(total - 1);
    pages.add(total - 2);
    pages.add(total - 3);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result: PageToken[] = [];
  for (let i = 0; i < sorted.length; i += 1) {
    if (i > 0 && sorted[i]! - sorted[i - 1]! > 1) {
      result.push('ellipsis');
    }
    result.push(sorted[i]!);
  }
  return result;
}

/** Clamp page into [1, totalPages] (totalPages min 1 when empty list still shows page 1). */
export function clampPage(page: number, itemCount: number, pageSize: number): number {
  const totalPages = Math.max(1, Math.ceil(Math.max(0, itemCount) / Math.max(1, pageSize)));
  return Math.min(Math.max(1, page), totalPages);
}
